window.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("header-nav")) {
    class HeaderNav extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initEvent();
        this.initFirstActive()
        this.initEventListeners();
        this.initKeyboardScope();
      }

      initEvent() {
        const btn = this.querySelectorAll(".header-link-btn");
        if (!btn) return;
        const headerWrapper = this.closest(".header-wrapper");
        for (let btn_item of btn) {
          btn_item.addEventListener("click", (e) => {
            window.open(btn_item.dataset.href, "_blank");
          });
        }


        for (const parent of this.querySelectorAll('.site-nav--has-dropdown')) {
          const $parents = $(parent);
          $parents.on('mouseenter touchstart focusin', this.onHoverParentNav);
          parent.addEventListener("focusin", () => {
            parent.classList.add("nav-hover");
            if (headerWrapper) {
              headerWrapper.classList.add("keyboard-nav-hover");
            }
            if (this.updateKeyboardScope) {
              this.updateKeyboardScope();
            }
          });
          parent.addEventListener("focusout", () => {
            setTimeout(() => {
              if (!parent.contains(document.activeElement)) {
                parent.classList.remove("nav-hover");
              }
              if (
                headerWrapper &&
                (!document.activeElement ||
                  !document.activeElement.closest(".site-nav--has-dropdown"))
              ) {
                headerWrapper.classList.remove("keyboard-nav-hover");
              }
              if (this.updateKeyboardScope) {
                this.updateKeyboardScope();
              }
            }, 10);
          });
        }
      }

      onHoverParentNav(e) {
        const target = e.currentTarget;
        if (target) {
          const navSwiperElements = target.querySelectorAll('header-nav-swiper');
          for (const navSwiper of navSwiperElements) {
            navSwiper.init();
          }
        }
      }

      initFirstActive(){
        const left_container_list = this.querySelectorAll(".left_nav-content")
       for(let item of left_container_list){
         const obj=item.querySelector(".menu-item.active")
         let name=obj.getAttribute("data-class_name")
         let customName = obj.querySelector(".header-title-custom") ? obj.querySelector(".header-title-custom").innerText : ""
         let url=obj.getAttribute("data-link")
         let subtitle=obj.querySelector(".header-title-content") ? obj.querySelector(".header-title-content").innerText:''
         item.parentElement.querySelector(".right_nav-active-text .active-left_text").innerText=customName || name
         item.parentElement.querySelector(".right_nav-active-text .active-left_subtitle").innerText=subtitle
        //  item.parentElement.querySelector(".right_nav-active-text .active-link a").setAttribute("href",url)
        this.setCollectoinUrl(obj)
       }
      }
      initEventListeners() {
        const menuItems = document.querySelectorAll(".site-nav__image-status .menu-item");
        const handleMenuItemActivate = function (menuItem) {
          const index = parseInt(menuItem.getAttribute("data-index")) - 1;
          const name = menuItem.getAttribute("data-name");
          const class_name = menuItem.getAttribute("data-class_name");
          const customName = menuItem.querySelector(".header-title-custom") ? menuItem.querySelector(".header-title-custom").innerText : ""
          const headerTitleContent = menuItem.querySelector(".header-title-content");
          const subtitle = headerTitleContent ? headerTitleContent.textContent : '';
          
          menuItem.classList.add("active");
          this.setCollectoinUrl(menuItem)
          const siblings = Array.from(menuItems).filter(el => el !== menuItem);
          siblings.forEach(el => el.classList.remove("active"));
          
          const imageStatus = menuItem.closest(".site-nav__image-status");
          if(imageStatus){
            const rightNavItems = Array.from(imageStatus.querySelectorAll(".right_nav-content>.item"));
            rightNavItems.forEach((item, i) => {
              if(i === index){
                item.classList.add("active");
              } else {
                item.classList.remove("active");
              }
            });
            
            const activeLeftText = imageStatus.querySelector(".right_nav-active-text .active-left_text");
            if(activeLeftText){
              activeLeftText.textContent = customName || class_name;
            }
            const activeLeftSubtitle = imageStatus.querySelector(".right_nav-active-text .active-left_subtitle");
            if(activeLeftSubtitle){
              activeLeftSubtitle.textContent = subtitle;
            }
          }
          
          const leftNavContent = menuItem.closest(".left_nav-content");
          if(leftNavContent){
            const menuDownLists = leftNavContent.querySelectorAll(`.header_nav-link-box .menu-down_list[data-name="${name}"]`);
            menuDownLists.forEach(list => {
              list.classList.add("active");
              const listSiblings = Array.from(list.parentElement.children).filter(el => el !== list);
              listSiblings.forEach(el => el.classList.remove("active"));
            });
          }
          if (this.updateKeyboardScope) {
            this.updateKeyboardScope();
          }
        };

        menuItems.forEach(function(menuItem) {
          menuItem.addEventListener("mouseenter", function () {
            handleMenuItemActivate.call(this.closest("header-nav"), this);
          });
          menuItem.addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
              event.preventDefault();
              handleMenuItemActivate.call(this.closest("header-nav"), this);
            }
          });
        });
        
        if (window.innerWidth > 1000) {
          const headerSection = document.getElementById("shopify-section-header");
          if(headerSection){
            headerSection.addEventListener("mouseleave", function () {
              const allElements = this.querySelectorAll("*");
              allElements.forEach(el => el.blur());
            });
          }
        }
        
        const languageBox = document.querySelectorAll(".choose-language-box");
        languageBox.forEach(item => {
            item.addEventListener("click", function () {
                const isExpanded = this.getAttribute("aria-expanded") === "true";

                this.setAttribute("aria-expanded", !isExpanded);

                document.querySelector(".pc-language-box .website_change_wrapper .item")?.click();
            });
        });

      }

      initKeyboardScope() {
        const focusableSelector = 'a[href], button, input, select, textarea, [tabindex], [data-managed-tabindex]';
        const managedAttr = "data-managed-tabindex";
        const headerSection = this.closest("#shopify-section-header");
        const navDrawer = document.getElementById("NavDrawer");
        const isVisibleForTab = (element) => {
          if (
            element.closest("[hidden]") ||
            element.closest('[aria-hidden="true"]')
          ) {
            return false;
          }
          if (
            element.closest("#NavDrawer") &&
            !document.body.classList.contains("js-drawer-open-left")
          ) {
            return false;
          }
          const rightNavPanel = element.closest(".right_nav-content .item");
          if (
            rightNavPanel &&
            rightNavPanel.parentElement &&
            rightNavPanel.parentElement.classList.contains("right_nav-content") &&
            !rightNavPanel.classList.contains("active")
          ) {
            return false;
          }
          const style = window.getComputedStyle(element);
          if (style.display === "none" || style.visibility === "hidden") {
            return false;
          }
          return element.getClientRects().length > 0;
        };
        const updateFocusableScope = () => {
          const focusables = new Set();
          if (headerSection) {
            headerSection
              .querySelectorAll(focusableSelector)
              .forEach((element) => focusables.add(element));
          }
          if (navDrawer) {
            navDrawer
              .querySelectorAll(focusableSelector)
              .forEach((element) => focusables.add(element));
          }
          focusables.forEach((element) => {
            const shouldDisable = !isVisibleForTab(element);
            if (shouldDisable) {
              if (!element.hasAttribute(managedAttr)) {
                const originalTabindex = element.getAttribute("tabindex");
                element.setAttribute(
                  managedAttr,
                  originalTabindex === null ? "" : originalTabindex
                );
              }
              element.setAttribute("tabindex", "-1");
              return;
            }
            if (element.hasAttribute(managedAttr)) {
              const originalTabindex = element.getAttribute(managedAttr);
              if (originalTabindex === "") {
                element.removeAttribute("tabindex");
              } else {
                element.setAttribute("tabindex", originalTabindex);
              }
              element.removeAttribute(managedAttr);
            }
          });
        };
        this.updateKeyboardScope = updateFocusableScope;
        updateFocusableScope();
        window.addEventListener("resize", updateFocusableScope);
        document.addEventListener("click", () => {
          setTimeout(updateFocusableScope, 0);
        });
        const bodyObserver = new MutationObserver(updateFocusableScope);
        bodyObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }

      setCollectoinUrl(activeMenuItemDom) {
        if (!activeMenuItemDom) return;
        const dropdown = activeMenuItemDom.closest(".site-nav__dropdown");
        if (!dropdown) return;
        const seeAll = dropdown
          ?.querySelector(".right_nav-active-text .active-link a");
        const activeLink = activeMenuItemDom.getAttribute("data-link");
        const hasValidActiveLink = this.isValidCollectionLink(activeLink);
        this.updateCollectionLinkByActiveItem(seeAll, activeLink);

        const existingViewAll = dropdown.querySelector(".header-bottom-buttons .view-all a");
        if (existingViewAll) {
          this.updateCollectionLinkByActiveItem(existingViewAll, activeLink);
        } else if (hasValidActiveLink) {
          const fallbackHref =
            (seeAll && (seeAll.getAttribute("data-original-href") || seeAll.getAttribute("href"))) || "/";
          const viewAll = this.getOrCreateViewAllLink(dropdown, fallbackHref);
          this.updateCollectionLinkByActiveItem(viewAll, activeLink);
        }

        if (!hasValidActiveLink) {
          this.removeDynamicViewAllStructures(dropdown);
        }
      }

      updateCollectionLinkByActiveItem(linkDom, activeLink) {
        if (!linkDom) return;
        if (!linkDom.hasAttribute("data-original-href")) {
          const initialHref = linkDom.getAttribute("href") || "";
          linkDom.setAttribute("data-original-href", initialHref);
        }
        const originalHref = linkDom.getAttribute("data-original-href") || "";
        if (originalHref !== "/") return;
        if (activeLink && activeLink !== "/") {
          linkDom.setAttribute("href", activeLink);
        } else {
          if (originalHref) {
            linkDom.setAttribute("href", originalHref);
          } else {
            linkDom.removeAttribute("href");
          }
        }
      }

      isValidCollectionLink(link) {
        return !!(link && link !== "/");
      }

      getOrCreateViewAllLink(dropdown, fallbackHref = "/") {
        let bottomButtons = dropdown.querySelector(".header-bottom-buttons");
        if (!bottomButtons) {
          bottomButtons = document.createElement("div");
          bottomButtons.className = "header-bottom-buttons";
          bottomButtons.setAttribute("data-dynamic-created", "true");
          dropdown.appendChild(bottomButtons);
        }

        let wrapper = bottomButtons.querySelector(".header-bottom-buttons-wrapper");
        if (!wrapper) {
          wrapper = document.createElement("div");
          wrapper.className = "header-bottom-buttons-wrapper";
          while (bottomButtons.firstChild) {
            wrapper.appendChild(bottomButtons.firstChild);
          }
          bottomButtons.appendChild(wrapper);
        }

        let viewAllButton = wrapper.querySelector(".header-bottom-button.view-all");
        if (!viewAllButton) {
          viewAllButton = document.createElement("div");
          viewAllButton.className = "header-bottom-button view-all";
          viewAllButton.setAttribute("data-dynamic-created", "true");

          const viewAllLink = document.createElement("a");
          viewAllLink.setAttribute("href", fallbackHref || "/");
          viewAllLink.setAttribute("target", "_blank");
          const maskId = `path-view-all-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
          viewAllLink.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
              <mask id="${maskId}" fill="white">
                <rect width="9.47368" height="20" rx="1"></rect>
              </mask>
              <rect width="9.47368" height="20" rx="1" stroke="black" stroke-width="4" mask="url(#${maskId})"></rect>
              <path d="M11.5789 2.10547H19.9999" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M11.5789 9.47266H19.9999" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M11.5789 16.8438H19.9999" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <div class="common-pc--hide">View All</div>
            <div class="common-small--hide">View All</div>
          `;
          viewAllButton.appendChild(viewAllLink);

          const compareButton = wrapper.querySelector(".header-bottom-button.compare-model");
          if (compareButton) {
            wrapper.insertBefore(viewAllButton, compareButton);
          } else {
            wrapper.appendChild(viewAllButton);
          }
        }

        this.syncBottomButtonSeparator(wrapper);
        return wrapper.querySelector(".header-bottom-button.view-all a");
      }

      removeDynamicViewAllStructures(dropdown) {
        if (!dropdown) return;
        const bottomButtons = dropdown.querySelector(".header-bottom-buttons");
        if (!bottomButtons) return;

        if (bottomButtons.getAttribute("data-dynamic-created") === "true") {
          bottomButtons.remove();
          return;
        }

        const wrapper = bottomButtons.querySelector(".header-bottom-buttons-wrapper");
        if (!wrapper) return;

        const dynamicViewAll = wrapper.querySelector('.header-bottom-button.view-all[data-dynamic-created="true"]');
        if (dynamicViewAll) {
          dynamicViewAll.remove();
        }

        this.syncBottomButtonSeparator(wrapper);
      }

      syncBottomButtonSeparator(wrapper) {
        if (!wrapper) return;
        const viewAllButton = wrapper.querySelector(".header-bottom-button.view-all");
        const compareButton = wrapper.querySelector(".header-bottom-button.compare-model");
        let sep = wrapper.querySelector(".header-bottom-button-sep");

        if (viewAllButton && compareButton) {
          if (!sep) {
            sep = document.createElement("div");
            sep.className = "header-bottom-button-sep";
          }
          wrapper.insertBefore(sep, compareButton);
        } else if (sep) {
          sep.remove();
        }
      }
    }
    customElements.define("header-nav", HeaderNav);
  }
  if (!customElements.get("header-nav-swiper")) {
    class HeaderNavSwiper extends HTMLElement {
      isFirstInit = true;
      constructor() {
        super();
        this.swiper = null;
        this.variant_btn = this.querySelectorAll(".header_variants-container");
      }

      init() {
        if (!this.isFirstInit) return;
        this.initSwiper();
        this.resizeEvent();
        this.initBtnEvent();
        this.initMbEvent();
        this.isFirstInit = false;
      }
      initBtnEvent() {
        for (let item of this.variant_btn) {
          let item_span = item.querySelectorAll("span");
          for (let item_child of item_span) {
            item_child.addEventListener("click", () => {
              const img_url = item_child.getAttribute("data-img_url");
              for (const child of item_child.parentElement.children) {
                child.classList.remove("active");
              }
              item_child.classList.add("active");
              item_child.parentElement.parentElement.parentElement.querySelector(
                ".site-nav__dropdown-linka img"
              ).src = img_url;
            });
          }
        }
      }
      initSwiper() {
        if (!!this.swiper) return;
        const swiperContainer = this.querySelector(".swiper-container");
        const scrollbar = this.querySelector(".swiper-scrollbar");
        let allowTouch =
          this.getAttribute("data-allow-touch") == "false" ? false : true;
        if (!swiperContainer) return;
        this.swiper = new Swiper(swiperContainer, {
          slidesPerView: "auto",
          allowTouchMove: allowTouch,
          observer: true,
          observeParents: true,
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
          navigation: {
            nextEl: this.querySelector(".swiper-button-prev"),
            prevEl: this.querySelector(".swiper-button-next"),
          },
        });
      }

      resizeEvent() {
        if (window.innerWidth < 1300) {
          this.swiper ? (this.swiper.allowTouchMove = true) : null;
        }
        window.addEventListener("resize", () => {
          if (this.swiper) {
            this.swiper.update();
          }
        });
      }
      initMbEvent() {
        if (window.innerWidth <= 1100) {
          let btn_items = this.querySelectorAll(".mobile-nav__toggle-btn");
          for (let btn_i of btn_items) {
            btn_i.addEventListener("click", () => {
              this.initSwiper();
            });
          }
        }
      }
    }
    customElements.define("header-nav-swiper", HeaderNavSwiper);
  }
  if (!customElements.get("drawer-menu")) {
    class DrawerMenu extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.initEventListeners();
      }
      initEventListeners() {
        const btn_link = this.querySelector(".drawer-menu-search-icon");
        btn_link.addEventListener("click", () => {
          document.querySelector(".site-nav__link--burger").click();
          document.querySelector(".new-search-container").click();
        });
      }
    }
    customElements.define("drawer-menu", DrawerMenu);
  }
  if (!customElements.get("header-drawer-menu")) {
    class HeaderDrawerMenu extends HTMLElement {
      constructor() {
        super();
        this.swiper_list_arr = [];
        this.variant_btn = this.querySelectorAll(".header_variants-container");
        this.swiper_list = this.querySelectorAll(".swiper-container");
        this.mobile_nav__imglink = this.querySelectorAll(
          ".mobile-nav__imglink"
        );
      }
      connectedCallback() {
        this.initEventListeners();
        this.initBtnEvent();
      }
      initBtnEvent() {
        for (let item of this.variant_btn) {
          let item_span = item.querySelectorAll("span");
          for (let item_child of item_span) {
            item_child.addEventListener("click", () => {
              const img_url = item_child.getAttribute("data-img_url");
              for (const child of item_child.parentElement.children) {
                child.classList.remove("active");
              }
              item_child.classList.add("active");
              item_child.parentElement.parentElement.parentElement.querySelector(
                ".site-nav__dropdown-linka img"
              ).src = img_url;
            });
          }
        }
      }
      initEventListeners() {
        for (let item of this.mobile_nav__imglink) {
          item.addEventListener("click", () => {
            let timer_id = setTimeout(() => {
              this.initSwiper();
              clearTimeout(timer_id);
            }, 100);
          });
        }
      }
      initSwiper() {
        if (this.swiper_list_arr.length > 0) return;
        for (let swiper_item of this.swiper_list) {
          const scrollbar = swiper_item.querySelector(".swiper-scrollbar");
          let swiper = new Swiper(swiper_item, {
            slidesPerView: "auto",
            scrollbar: {
              el: scrollbar,
              draggable: true,
            },
          });
          this.swiper_list_arr.push(swiper);
        }
      }
    }
    customElements.define("header-drawer-menu", HeaderDrawerMenu);
  }
});
